import React, { useEffect, useState } from 'react';
import { Button, Modal, Input } from 'reactstrap';
import SpinnerCircles from './Spinner/SpinerCircles';

const headLabel = 'New Category';

const AddOobCategoryModal = ({ isOpen, onSubmit, cancelHandler, loading, error = '', success = '' }) => {

  const [inputText, setInputText] = useState('');
  const onChange = (e) => {
    setInputText(e.target.value)
  }
  const onSave = (e) => {
    inputText && onSubmit(inputText)
  }

  useEffect(() => {
    if (success) {
      setInputText('')
    }
  }, [success])


  return (
    <Modal isOpen={isOpen} style={{ width: '50%', }}>
      <div className="add-oob-category-container">
        <label className='modal-clr-heading'>{headLabel}</label>
        {error && <p className='error-text'> {error}</p>}
        {success && <p className='success-text'> {success}</p>}
        <div className='management-modal-content-section mt-2'>
          <Input
            placeholder="Add Category"
            required
            type="text"
            name="epikCustomerId"
            value={inputText}
            onChange={onChange}
          />
          <div className='management-modal-btn-section mt-3'>
            <Button color="primary" disabled={loading || !inputText} onClick={onSave} className='ml-2'>
              {loading ? <SpinnerCircles /> : 'Save'}
            </Button>
            <Button outline onClick={cancelHandler}> Cancel </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
};

export default AddOobCategoryModal;
